import { ActionReducerMap } from '@ngrx/store';
import { GlobalState } from './states/global.state';
import { userReducer } from './reducers/user.reducers';

export const reducers: ActionReducerMap<GlobalState> = {
  user: userReducer
};
